import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, unref as _unref, isRef as _isRef, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "my-16 text-center" }
const _hoisted_2 = { class: "w-[90%] w-sm-1/2 mx-auto" }
const _hoisted_3 = {
  key: 0,
  class: "text-gray-400 py-2"
}
const _hoisted_4 = {
  key: 1,
  class: "text-red-400 py-2"
}

import {  differenceInDays,format as formatDate } from "date-fns";
import { computed, ref, watch } from "vue";
import BookingOrder from "@/components/BookingOrder.vue";
import BookingCalendar from "@/components/BookingCalendar.vue";
import { getPriceList, getPublicFreeDates, RoomAvailability } from "@/lib/bookings";
import { Pricing } from "@shared/types";


export default /*#__PURE__*/_defineComponent({
  __name: 'Book',
  setup(__props) {

let searchInputDates = ref([]);

let searchLoading = ref(false);

let availableRooms: RoomAvailability[] | null = null;

let priceList: Pricing[] | null = null;

const searchAvailability = async () => {
  // console.log(ev);
  searchLoading.value = true;
  let checkin = formatDate(searchInputDates.value[0],"yyyy-MM-dd");
  let checkout = formatDate(searchInputDates.value[1],"yyyy-MM-dd");
  availableRooms = await getPublicFreeDates({ checkin, checkout }) || null;
  priceList = await getPriceList({ checkin, checkout }) || null;
  searchLoading.value = false;
};

const viewDate = ref(new Date());

watch(searchInputDates, async (newD) => {
  if (newD[0]) {
    viewDate.value = newD[0];
    // console.log(viewDate.value);
    // availableRooms = await getPublicFreeDates({ checkin: newD[0], checkout: newD[1] });
    availableRooms = null;
  }
});

const nights = computed(() => {
  if (searchInputDates?.value?.length == 2)
    return differenceInDays(searchInputDates.value[1], searchInputDates.value[0]);
  else return 0;
});

return (_ctx: any,_cache: any) => {
  const _component_HeaderDefault = _resolveComponent("HeaderDefault")!
  const _component_VueDatepicker = _resolveComponent("VueDatepicker")!
  const _component_Button = _resolveComponent("Button")!
  const _component_DefaultLayout = _resolveComponent("DefaultLayout")!

  return (_openBlock(), _createBlock(_component_DefaultLayout, null, {
    default: _withCtx(() => [
      _createVNode(_component_HeaderDefault, {
        title: "Book your stay",
        small: ""
      }),
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createVNode(_component_VueDatepicker, {
            placeholder: "Select check-in and check-out dates",
            range: "",
            "enable-time-picker": false,
            "min-date": new Date(),
            format: "PPPP",
            modelValue: _unref(searchInputDates),
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_isRef(searchInputDates) ? (searchInputDates).value = $event : searchInputDates = $event))
          }, null, 8, ["min-date", "modelValue"])
        ]),
        (_unref(nights))
          ? (_openBlock(), _createElementBlock("div", _hoisted_3, _toDisplayString(_unref(nights)) + " nights", 1))
          : _createCommentVNode("", true),
        _createVNode(_component_Button, {
          class: "mt-6",
          label: "Search Availability",
          disabled: !_unref(nights) || _unref(searchLoading) || _unref(nights) < 2,
          onClick: searchAvailability,
          loading: _unref(searchLoading)
        }, null, 8, ["disabled", "loading"]),
        (_unref(nights) && _unref(nights) < 2)
          ? (_openBlock(), _createElementBlock("div", _hoisted_4, " 2 night minimum stay is required. "))
          : _createCommentVNode("", true)
      ]),
      _createVNode(BookingOrder, {
        availability: _unref(availableRooms),
        searchDates: _unref(searchInputDates),
        priceList: _unref(priceList)
      }, null, 8, ["availability", "searchDates", "priceList"]),
      _createVNode(BookingCalendar, { today: viewDate.value }, null, 8, ["today"])
    ]),
    _: 1
  }))
}
}

})